(function socialShare() {

	if (document.querySelectorAll('.js-copy-link')) {
		
		Array.from(document.querySelectorAll('.js-copy-link')).forEach(share => {
			let timer;
			share.addEventListener('click', e => {
				share.parentNode.querySelector('.status-message').classList.add('copied');
				const pageUrl = window.location.href;
				
				navigator.clipboard.writeText(pageUrl)
				.then(() => {
					timer = setTimeout(() => {
						share.parentNode.querySelector('.status-message').classList.remove('copied');
					}, 1500)
				})
				.catch(err => {
					console.error('Error in copying text: ', err);
				});
			
			})
		})
	}
})();